<template>
    <a href="" class="back-top" @click.prevent="scrollToTop"
        ><img src="../assets/images/backtop.png" alt=""
    /></a>
</template>

<script>
export default {
    name: "BackToTop",
    methods: {
        scrollToTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        }
    }
};
</script>
